import { z } from "zod";

import { nullToUndefined } from "./phase2-api-parse-utils.ts";

export const phase2PendingBankDetailsSchema = z.preprocess(
  nullToUndefined,
  z
    .object({
      id: z.union([z.number(), z.string()]).nullish(),
      approvalStatus: z.string().nullish(),
      beneficiaryName: z.string().nullish(),
      branchName: z.string().nullish(),
      cancelledChequePath: z.string().nullish(),
      bankName: z.string().nullish(),
      accountNumber: z.string().nullish(),
      ifscCode: z.string().nullish(),
      bankZipCode: z.string().nullish(),
      bankPostcode: z.string().nullish(),
    })
    .passthrough(),
);

const phase2PendingRowSchemaInner = z
  .object({
    approvalStatus: z.string().nullish(),
    employeeName: z.string().nullish(),
    bankDetails: phase2PendingBankDetailsSchema.nullish(),
    phase2Id: z.union([z.number(), z.string()]),
    submittedOn: z.string().nullish(),
    employeeId: z.union([z.number(), z.string()]).nullish(),
    email: z.string().nullish(),
    employeeCode: z.string().nullish(),
    status: z.string().nullish(),
    employee: z
      .object({
        id: z.union([z.number(), z.string()]).nullish(),
        personalEmail: z.string().nullish(),
        ccEmail: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
  })
  .passthrough();

export const phase2PendingRowSchema = z.preprocess(
  nullToUndefined,
  phase2PendingRowSchemaInner,
);

export type Phase2PendingBankDetails = z.infer<typeof phase2PendingBankDetailsSchema>;
export type Phase2PendingRow = z.infer<typeof phase2PendingRowSchemaInner>;

function parsePendingListItems(rawItems: unknown[]): Phase2PendingRow[] {
  const rows: Phase2PendingRow[] = [];
  for (const item of rawItems) {
    const parsed = phase2PendingRowSchema.safeParse(item);
    if (parsed.success) rows.push(parsed.data);
  }
  return rows;
}

export function parsePhase2PendingList(raw: unknown): Phase2PendingRow[] {
  const sanitized = nullToUndefined(raw);
  const asArray = z.array(z.unknown()).safeParse(sanitized);
  if (asArray.success) return parsePendingListItems(asArray.data);

  if (sanitized != null && typeof sanitized === "object") {
    const record = sanitized as Record<string, unknown>;
    const data = record.data;
    if (Array.isArray(data)) return parsePendingListItems(data);
  }

  return [];
}